import { type ComponentProps } from 'react';
import { useField } from 'formik';

import Checkbox from '../Checkbox/Checkbox';

type FormikCheckboxProps = {
  name: string;
  dataTestid?: string;
} & ComponentProps<typeof Checkbox>;

const FormikCheckbox = ({
  name,
  dataTestid = 'FormikCheckbox',
  ...checkboxProps
}: FormikCheckboxProps) => {
  const [{ value, ...field }, meta] = useField(name);

  return (
    <Checkbox
      {...field}
      {...checkboxProps}
      checked={value}
      data-testid={dataTestid}
      errorMessage={meta.touched && meta.error ? meta.error : undefined}
    />
  );
};

export default FormikCheckbox;
